export { default } from './magnify-image';
